import React, { forwardRef, useState } from "react";
import { Button, Col, Input, message, Modal, Row, Select, Spin } from "antd";
import styles from "./index.module.scss";
import ReloadBtn from "../../../../../invigilationLog/components/ReloadBtn";
import Layout from "../../../../../invigilationLog/components/Layout";
import Aside from "../Aside";
import useRequest from "../../../../../../../utils/useRequest";
import {
    ExamListItem,
    getExamInfo,
    getExamListByInvigilation,
    getInvigilationStudentByExamId,
    getStuProps,
    InvigilationStuListItem,
    updateMeetingProps,
    updateMeetingRoom
} from "../../../../../../../service/exam";
import Form from "rc-field-form";
import useRequestFn from "../../../../../../../utils/useRequestFn";
import { errorMessage } from "../../../../../../../service/service";
import Table from "../Table";
import FieldWithError from "../../../../../../../components/FieldWithError";
import useSelection from "../../../../../../../utils/v2/useSelection";
import useModalHandler from "../../../../../../../utils/v3/useModalHandler";
import RoomModal from "../RoomModal";
import lodash from "lodash-es";
import { MachineRoomModal } from "../MachineRoomModal";

interface DataModalInstance {}
interface DataModalProps {}

const formItemProps = {
    style: {
        width: "100%"
    }
};

const infoModal = forwardRef<DataModalInstance, DataModalProps>(
    ({ ...props }, ref) => {
        const roomModal = useModalHandler({ component: RoomModal });

        const machineRoomModal = useModalHandler({
            component: MachineRoomModal
        });

        const [options, { loading: optionsLoading }] = useRequest(
            getExamListByInvigilation
        );
        const rowSelection = useSelection();
        const [form] = Form.useForm<getStuProps>();
        const [search, setSearch] = useState<getStuProps>({
            examId: "",
            search: ""
        });
        const [tableData, { loading }, refresh] = useRequest(
            () => getInvigilationStudentByExamId(search),
            {},
            [search]
        );

        const [getInfo, { loading: infoLoading }] = useRequestFn(getExamInfo);
        const [infoData, setInfoData] = useState<ExamListItem | null>(null);
        const [tableKey, ToggleTable] = useState(0);
        async function handleFinish(params: getStuProps) {
            rowSelection.setSelected([]);
            try {
                setSearch(params);
                ToggleTable(i => i + 1);
                const infoData = await getInfo(params.examId);
                setInfoData(infoData);
            } catch (e) {
                message.error(errorMessage(e));
            }
        }

        const [updateAction] = useRequestFn(updateMeetingRoom);
        async function roomOk(meetingRoom: string) {
            roomModal.close();
            const studentNoArr = rowSelection.selected.map(detailId => {
                const item = lodash.find(tableData, {
                    detailId
                }) as InvigilationStuListItem;
                return item.studentNo;
            });
            const params: updateMeetingProps = {
                detailId: rowSelection.selected.join(","),
                meetingRoom,
                examId: infoData?.examId || "",
                studentNo: studentNoArr.join(",")
            };
            try {
                await updateAction(params);
                await refresh();
            } catch (e) {
                message.error(errorMessage(e));
            }
        }

        const [activeItem, setActiveItem] =
            useState<null | InvigilationStuListItem>(null);
        function onSelect(item: InvigilationStuListItem) {
            setActiveItem(item);
        }

        return (
            <Modal
                {...props}
                centered
                width={1200}
                className={styles.root}
                title="查看考核详情"
                footer={false}>
                <Form
                    className={styles.before}
                    form={form}
                    onFinish={handleFinish}>
                    <Row type="flex" align="top" gutter={15} justify="end">
                        <Col span={2} className={styles.label}>
                            <span style={{ color: "red" }}>*</span>考核：
                        </Col>
                        <Col span={4}>
                            <FieldWithError
                                rules={[
                                    { required: true, message: "请选择考核" }
                                ]}
                                name="examId">
                                <Select
                                    {...formItemProps}
                                    loading={optionsLoading}>
                                    {options?.map(item => (
                                        <Select.Option
                                            key={item.examId}
                                            value={item.examId}>
                                            {item.examName}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </FieldWithError>
                        </Col>
                        <Col span={2} className={styles.label}>
                            学生信息：
                        </Col>
                        <Col span={4}>
                            <Form.Field name="search">
                                <Input
                                    {...formItemProps}
                                    placeholder="请输入学号或姓名"
                                />
                            </Form.Field>
                        </Col>
                        <Col span={2}>
                            <Button
                                icon="search"
                                htmlType="submit"
                                type="primary">
                                搜索
                            </Button>
                        </Col>
                        <Col span={4}>
                            <Button
                                disabled={rowSelection.selected.length === 0}
                                onClick={() => roomModal.open()}
                                type="primary"
                                {...formItemProps}>
                                维护腾讯会议考场信息
                            </Button>
                        </Col>

                        <Col span={4}>
                            <Button
                                disabled={rowSelection.selected.length === 0}
                                onClick={() =>
                                    machineRoomModal.open({
                                        selected: rowSelection.selected,
                                        onOk: () => {
                                            machineRoomModal.close();
                                            refresh();
                                            rowSelection.setSelected([]);
                                        }
                                    })
                                }
                                type="primary"
                                {...formItemProps}>
                                机房维护
                            </Button>
                        </Col>
                    </Row>
                </Form>
                <Spin spinning={loading}>
                    <Layout
                        showInfo={false}
                        showTab={false}
                        showTitle={false}
                        title="参考全过程记录"
                        extra={<ReloadBtn onReload={refresh} />}
                        table={
                            <Table
                                onSelect={onSelect}
                                key={tableKey}
                                rowSelection={rowSelection}
                                data={tableData || []}
                            />
                        }
                        aside={
                            <Aside
                                activeItem={activeItem}
                                loading={infoLoading}
                                infoData={infoData}
                            />
                        }
                    />
                </Spin>

                {roomModal.render(<RoomModal onOk={roomOk} />)}
                {machineRoomModal.render()}
            </Modal>
        );
    }
);

export default infoModal;
